import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        goodsorderarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_GOODSORDER: (state, obj) => {

            state.total = obj.total
            state.goodsorderarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.goodsorderarr.splice(index,1)
        },
        CLEAR_GOODSORDER: (state) => {

            state.total = 0
            state.goodsorderarr=[]

        },


    },
    actions: {
        async getGoodsorder({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getgoodsorder(params)
            if (code == 200) {
                commit('SET_GOODSORDER', data);
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}